module.exports = __webpack_public_path__ + "img/386.2feec139.svg";